/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';
import { ICheckoutApplePayViewProps } from './checkout-apple-pay';

const CheckoutApplyPayView: React.FC<ICheckoutApplePayViewProps> = ({ checkoutApplyPay, applePayButton }) => (
    <Module {...checkoutApplyPay}>{applePayButton}</Module>
);

export default CheckoutApplyPayView;
